import { contactInfo } from '@/mocks/siteData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            {contactInfo.title}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">{contactInfo.desc}</p>
        </div>

        <div className="bg-background-50 border border-background-200/60 rounded-2xl p-6 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {contactInfo.tips.map((tip, i) => (
              <div
                key={i}
                className="flex flex-col items-center text-center p-5 bg-background-100 rounded-xl"
              >
                <div className="w-12 h-12 mb-4 bg-primary-100 rounded-full flex items-center justify-center">
                  <i className={`${tip.icon} text-xl text-primary-600`}></i>
                </div>
                <p className="text-foreground-700 text-sm leading-relaxed">{tip.text}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 pt-6 border-t border-background-200/60 text-center">
            <p className="text-foreground-400 text-xs">
              我们承诺对所有投稿信息严格保密，重大独家爆料线索一经采用，将给予丰厚奖励
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}